import * as React from 'react';
import { DyCampaign as DyCampaignBase } from '@lib/dy';

interface DyCampaignProps {
  campaignName: string;
}

export const DyCampaign: React.FC<DyCampaignProps> = ({ campaignName }) => {
  return <DyCampaignBase name={campaignName}></DyCampaignBase>;
};
